<template>
  <div class="text-center">
    <gauge-chart :data="data.pointValue" :extend-data="extendData" :max="data.visualHigh" :min="data.visualLow"
                 class="gaugeChart"/>
    <div class="text-lightBlue gaugePointValueName">{{ data.pointValueName }}</div>
    <div class="text-blueGrey gaugePointName">{{ data.pointName }}</div>
  </div>
</template>

<script>
import GaugeChart from "@/components/echarts/GaugeChart1";

export default {
  name: "PointGauge",
  components: {GaugeChart},
  props: ['data', 'extendData'],
}
</script>

<style scoped>

.gaugeChart {
  width: 120px;
  height: 100px;
  margin: auto
}

.gaugePointValueName {
  width: 120px;
  height: 25px;
  text-align: center;
  font-size: 1.3rem;
  margin: auto
}

.gaugePointName {
  width: 120px;
  text-align: center;
  font-size: 0.9rem;
  margin: auto;
}

</style>
